export enum QuickActionType {
  CreateOrder = 'CreateOrder',
  InviteCustomer = 'InviteCustomer',
  SearchOrders = 'SearchOrders',
  SearchCustomers = 'SearchCustomers',
  CreditLimitIncreaseInvite = 'CreditLimitIncreaseInvite',
  RepaymentCalculator = 'RepaymentCalculator',
  DisbursementReports = 'DisbursementReports',
  ManageUsers = 'ManageUsers',
  ProductsConfiguration = 'ProductsConfiguration',
}
